// "Load sample" presets for the Buyer integration screen (CU-LS-M1-050).
// Three buyer styles from the phase-0 buyer specs (LiftUp, Leadtree/Phonexa, Acquire /loan/).
// PLACEHOLDER values only: no real source keys, user names, URLs or secrets. Secrets are env var
// NAMES (LDS_BUYER_SECRET_*); ops sets the values on the API service.

const liftUpStyle = {
  key: "jsonHeaderAuth",
  label: "JSON + header auth (LiftUp style)",
  description:
    "JSON body, API key in a request header, text status mapped to sold/rejected, enum map for pay frequency.",
  requestTemplate: {
    format: "json",
    fields: [
      { buyerField: "source", value: "PLACEHOLDER_SOURCE" },
      { buyerField: "lead_type", value: "PLACEHOLDER_LEAD_TYPE" },
      { buyerField: "lead_id", ldsField: "id" },
      { buyerField: "tcpa_opt_in", ldsField: "consentEmailSms" },
      { buyerField: "first_name", ldsField: "firstName", transforms: ["trim"], required: true },
      { buyerField: "last_name", ldsField: "lastName", transforms: ["trim"], required: true },
      { buyerField: "email", ldsField: "email", transforms: ["trim", "lower"], required: true },
      { buyerField: "phone_number", ldsField: "homePhone", transforms: ["digits_only"], required: true },
      { buyerField: "address_line_1", ldsField: "address", required: true },
      { buyerField: "city", ldsField: "city", required: true },
      { buyerField: "state", ldsField: "state", transforms: ["upper"], required: true },
      { buyerField: "zip", ldsField: "zip", required: true },
      {
        buyerField: "pay_frequency",
        ldsField: "incomePaymentFrequency",
        required: true,
        valueMap: [
          { from: "Weekly", to: "Weekly" },
          { from: "Biweekly", to: "BiWeekly" },
          { from: "TwiceMonthly", to: "TwiceMonthly" },
          { from: "Monthly", to: "Monthly" },
        ],
      },
    ],
    auth: {
      type: "header",
      headerName: "Authorization",
      secretRef: "LDS_BUYER_SECRET_EXAMPLE_JSON_API_KEY",
    },
  },
  responseRules: {
    format: "json",
    statusPath: "result",
    outcomes: [
      { value: "PLACEHOLDER_SUCCESS", outcome: "sold" },
      { value: "FAIL", outcome: "rejected" },
    ],
    reasonPath: "details",
  },
  timeouts: { timeout: 10000 },
};

const leadtreeStyle = {
  key: "formBodyCreds",
  label: "Form post + body credentials (Leadtree / Phonexa style)",
  description:
    "Form-encoded post, API id and password sent in the body from env vars, numeric status 1/2/4, price and redirect read back.",
  requestTemplate: {
    format: "form",
    fields: [
      { buyerField: "apiId", secretRef: "LDS_BUYER_SECRET_EXAMPLE_FORM_API_ID" },
      { buyerField: "apiPassword", secretRef: "LDS_BUYER_SECRET_EXAMPLE_FORM_API_PASSWORD" },
      { buyerField: "testMode", ldsField: "testMode" },
      { buyerField: "productId", value: "1" },
      { buyerField: "price", ldsField: "price", required: true },
      { buyerField: "loanAmount", ldsField: "loanAmount", required: true },
      {
        buyerField: "incomeType",
        ldsField: "incomeType",
        required: true,
        valueMap: [
          { from: "Employment", to: "EMPLOYMENT" },
          { from: "Benefits", to: "BENEFITS" },
        ],
      },
      { buyerField: "incomeNextDate1", ldsField: "incomeNextDate1", transforms: ["date:yyyy-MM-dd"], required: true },
      { buyerField: "firstName", ldsField: "firstName", transforms: ["trim"], required: true },
      { buyerField: "lastName", ldsField: "lastName", transforms: ["trim"], required: true },
      { buyerField: "dob", ldsField: "dob", transforms: ["date:yyyy-MM-dd"], required: true },
      { buyerField: "email", ldsField: "email", transforms: ["trim", "lower"], required: true },
      { buyerField: "homePhone", ldsField: "homePhone", transforms: ["digits_only"], required: true },
      { buyerField: "workPhone", ldsField: "workPhone", transforms: ["digits_only"], required: true },
      { buyerField: "jobTitle", ldsField: "jobTitle", omitIfEmpty: true },
      {
        buyerField: "creditRating",
        ldsField: "creditScore",
        omitIfEmpty: true,
        unmappedValue: "",
        valueMap: [
          { from: "Excellent", to: "GREAT" },
          { from: "Good", to: "GOOD" },
          { from: "Fair", to: "FAIR" },
          { from: "Poor", to: "POOR" },
        ],
      },
      { buyerField: "zip", ldsField: "zip", required: true },
      { buyerField: "userIp", ldsField: "userIp", required: true },
      { buyerField: "userAgent", ldsField: "userAgent", required: true },
      { buyerField: "clickid", ldsField: "id" },
    ],
    auth: { type: "none" },
  },
  responseRules: {
    format: "json",
    statusPath: "status",
    numericStatus: true,
    outcomes: [
      { value: "1", outcome: "sold" },
      { value: "2", outcome: "rejected" },
      { value: "4", outcome: "error" },
    ],
    pricePath: "price",
    redirectUrlPath: "redirect_url",
  },
  timeouts: { timeout: 10000 },
};

const acquireStyle = {
  key: "minPricePost",
  label: "Min-price post (Acquire /loan/ style)",
  description:
    "JSON post with our floor as minimum_price, basic auth from an env var, text status, payout and redirect read back, 10 s buyer minimum.",
  requestTemplate: {
    format: "json",
    fields: [
      { buyerField: "source_key", secretRef: "LDS_BUYER_SECRET_EXAMPLE_MINPRICE_SOURCE_KEY" },
      { buyerField: "minimum_price", ldsField: "price", required: true },
      { buyerField: "first_name", ldsField: "firstName", transforms: ["trim"], required: true },
      { buyerField: "last_name", ldsField: "lastName", transforms: ["trim"], required: true },
      { buyerField: "primary_email", ldsField: "email", transforms: ["trim", "lower"], required: true },
      { buyerField: "mobile_phone", ldsField: "homePhone", transforms: ["digits_only"], required: true },
      { buyerField: "date_of_birth", ldsField: "dob", transforms: ["date:yyyy-MM-dd"] },
      { buyerField: "street_address", ldsField: "address" },
      { buyerField: "city", ldsField: "city" },
      { buyerField: "state", ldsField: "state", transforms: ["upper"] },
      { buyerField: "zip", ldsField: "zip" },
      { buyerField: "pay_frequency", ldsField: "incomePaymentFrequency", transforms: ["upper"] },
      { buyerField: "monthly_income", ldsField: "incomeNetMonthly" },
      { buyerField: "next_pay_date", ldsField: "incomeNextDate1", transforms: ["date:yyyy-MM-dd"] },
      { buyerField: "client_ip_address", ldsField: "userIp" },
      { buyerField: "user_agent", ldsField: "userAgent" },
      { buyerField: "source_lead_id", ldsField: "id" },
      { buyerField: "timeout", ldsField: "buyerTimeoutSeconds" },
    ],
    auth: {
      type: "basic",
      username: "PLACEHOLDER_USERNAME",
      secretRef: "LDS_BUYER_SECRET_EXAMPLE_MINPRICE_PASSWORD",
    },
  },
  responseRules: {
    format: "json",
    statusPath: "status",
    outcomes: [
      { value: "ACCEPTED", outcome: "sold" },
      { value: "REJECTED", outcome: "rejected" },
      { value: "PRICE_REJECT", outcome: "rejected" },
      { value: "ERROR", outcome: "error" },
    ],
    pricePath: "payout",
    redirectUrlPath: "redirect_url",
    reasonPath: "status",
  },
  timeouts: { timeout: 11000, minTimeoutMs: 10000 },
};

export const BUYER_INTEGRATION_SAMPLES = [liftUpStyle, leadtreeStyle, acquireStyle];

// A fresh deep copy so edits in the editor never mutate the preset.
export function getSample(key) {
  const sample = BUYER_INTEGRATION_SAMPLES.find((s) => s.key === key);
  return sample ? JSON.parse(JSON.stringify(sample)) : null;
}
